import { isDatePast } from '../../lib/dates';

function isCampaignCompleted(campaign) {
  return campaign.isCompleted || campaign.availableVoterCount < 1 || isDatePast(campaign.mailEndDate);
}

// eslint-disable-next-line import/prefer-default-export
export { isCampaignCompleted };
